import React, { Component } from "react";
import { connect } from "react-redux";
import { replace, push } from "connected-react-router";
import classNames from "classnames";
import { actions as sessionActions } from "reducers/session";

import { actions as loginActions } from "reducers/login";
import MainContainer from "pages/_components/MainContainer";
import Notification from "pages/_components/Notification";
import Head from "pages/_components/Head";

import I18n from "pages/_components/I18n";
import Step7Content from "./_components/Step7Content";

class LoginStep7 extends Component {
    onCancel = () => {
        const { dispatch } = this.props;
        dispatch(loginActions.reset());
        dispatch(sessionActions.logout());
        dispatch(push("/"));
    };

    onHeaderBack = () => {
        const { dispatch } = this.props;
        dispatch(replace("/"));
    };

    render() {
        const { isDesktop, isMobile } = this.props;
        const mainContainerClass = classNames({
            "main-container": true,
            "container-fluid": this.props.isDesktop,
        });

        return (
            <>
                {isMobile && (
                    <div className="terms_and_conditions">
                        <header className="view-header header-simple">
                            <h1 className="text-center" />
                        </header>

                        <Notification scopeToShow="loginStep7" />
                        <MainContainer className={mainContainerClass}>
                            <h1 className="text-center">
                                <I18n id="terms.condition.pf.title" />
                            </h1>
                            <Step7Content isDesktop={isDesktop} isMobile={isMobile} onCancel={this.onCancel} />
                        </MainContainer>
                    </div>
                )}
                {isDesktop && (
                    <>
                        <Head
                            title=""
                            styleOther={{ backgroundColor: "transparent", boxShadow: "none" }}
                            onBack={this.onHeaderBack}
                            hideNavbarInMobile
                        />
                        <Notification scopeToShow="loginStep7" />
                        <MainContainer className={mainContainerClass}>
                            <h1 className="text-center">
                                <I18n id="terms.condition.pf.title" />
                            </h1>
                            <Step7Content isDesktop={isDesktop} isMobile={isMobile} onCancel={this.onCancel} />
                        </MainContainer>
                    </>
                )}
            </>
        );
    }
}

export default connect()(LoginStep7);
